import { makeApiCall, makeFormApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/******************* GET AUDIT TRAIL REPORT START *****************/
export const auditTrailReportGet = (listData: any) => {
	const data = {
		AuditTrailToken: listData,
	};
	const url = `${API_URL}getAuditReport`;
	return makeApiCall(url, data);
};
/******************* GET AUDIT TRAIL REPORT END *****************/

/** ***************** AUDIT TRAIL REPORT REPORT EXCEL START *********************** */
export const auditTrailReportExcelget = (branchData: string) => {
	const params = new URLSearchParams();
	params.append('auditTrailToken', branchData);
	const url = `${API_URL}/Excel/AuditTrailReportExportwithtoken.php`;
	return makeFormApiCall(url, params);
};
/** ***************** AUDIT TRAIL REPORT REPORT EXCEL END *********************** */

/** ***************** FETCH POST AUDIT TRAIL REPORT JSON START *********************** */
export const auditTrailReportJSONGet = (listData: any) => {
	const data = {
		AuditTrailReportJsonToken: listData,
	};
	const url = `${API_URL}getAuditReportJson`;
	return makeApiCall(url, data);
};
/** ***************** FETCH POST AUDIT TRAIL REPORT JSON END *********************** */
